import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FieldTypeEnum } from '../../../../enums/fieldType.enum';
import { FiltroPadraoService } from '../../../../services/filtro-padrao.service';
import { CHAVE_CAMPO_CLIENTE, CHAVE_CAMPO_UNIDADE, ENTIDADE_TICKET_ID, ENTIDADES_FILTRO, montaOperadores, TIPOS_OPERADOR_CONDICAO } from '../../helpers/filtro-avancado-v2.helper';

@Component({
  selector: 'app-modal-condicao-filtro-avancado-v2',
  templateUrl: './modal-condicao-filtro-avancado-v2.component.html',
  styleUrls: ['./modal-condicao-filtro-avancado-v2.component.scss']
})
export class ModalCondicaoFiltroAvancadoV2Component implements OnInit {
  @Input() condicao: any;
  // clientes das condições de Cliente da mesma lista, usados para carregar as unidades
  @Input() clientesSelecionados: Array<any> = [];

  condicaoForm: UntypedFormGroup;
  create = true;
  campoSelecionado: any = null;
  entidadesFiltro = ENTIDADES_FILTRO;
  valorSelecionado: any = null;
  operadoresCondicao: Array<{ id: number; text: string; tipo_operador_id: number }> = [];
  clientesUnidade: Array<any> = [];
  clienteUnidade: any = null;
  unidadeParams: any = null;

  readonly fieldTypeEnum = FieldTypeEnum;
  readonly chaveCampoCliente = CHAVE_CAMPO_CLIENTE;
  readonly chaveCampoUnidade = CHAVE_CAMPO_UNIDADE;
  // Campos de data ficam só no Período; campos personalizados do ticket entram na lista (MIL-30113).
  readonly paramsCampos = { excluirTipoCampoId: FieldTypeEnum.Data, camposPersonalizados: true };

  private selector: string;

  constructor(
    public modal: NgbActiveModal,
    private elemRef: ElementRef,
    private fb: UntypedFormBuilder,
    private filtrosService: FiltroPadraoService
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
    this.create = !this.condicao;
    this.buildForm();
    this.carregaOperadores(this.condicao?.tipo_campo_id);
    // A unidade é filtrada por um único cliente.
    this.clientesUnidade = (this.clientesSelecionados || []).slice(0, 1);
    this.clienteUnidade = this.clientesUnidade.length ? { id: this.clientesUnidade[0] } : null;
    this.atualizaUnidadeParams();
  }

  carregaOperadores(tipoCampoId: number): void {
    this.operadoresCondicao = [];
    if (!tipoCampoId) {
      return;
    }

    this.filtrosService.getDropdownOperadores({ tipo_campo_id: tipoCampoId }).subscribe(
      (results) => this.operadoresCondicao = montaOperadores(results, TIPOS_OPERADOR_CONDICAO),
      () => this.operadoresCondicao = []
    );
  }

  // Unidade de negócio depende do cliente: trocar o cliente limpa as unidades escolhidas.
  patchClientesUnidade(cliente: any): void {
    this.clientesUnidade = (cliente !== null && cliente !== undefined) ? [cliente] : [];
    this.condicaoForm.patchValue({ valor: null });
    this.valorSelecionado = null;
    this.atualizaUnidadeParams();
  }

  private atualizaUnidadeParams(): void {
    this.unidadeParams = this.clientesUnidade.length ? { chave: CHAVE_CAMPO_UNIDADE, query: { cliente_id: this.clientesUnidade.join(';') } } : null;
  }

  buildForm(): void {
    this.condicaoForm = this.fb.group({
      entidade_id: [this.condicao?.entidade_id || ENTIDADE_TICKET_ID, Validators.required],
      campo_id: [this.condicao?.campo_id || null, Validators.required],
      campo_text: [this.condicao?.campo_text || null],
      operador_id: [this.condicao?.operador_id || null, Validators.required],
      valor: [this.condicao?.valor ?? null, Validators.required],
      tipo_campo_id: [this.condicao?.tipo_campo_id || null],
      campo_chave: [this.condicao?.campo_chave || null],
      campo_personalizado_id: [this.condicao?.campo_personalizado_id || null],
      operador_logico_id: [this.condicao?.operador_logico_id || null]
    });


    if (this.condicao) {
      // No select, o campo personalizado é identificado pela chave (todos têm o mesmo campo_id do contêiner).
      const idCampo = this.condicao.campo_personalizado_id ? this.condicao.campo_chave : this.condicao.campo_id;
      this.campoSelecionado = { id: idCampo, text: this.condicao.campo_text };

      const tipoCampoId = Number(this.condicao.tipo_campo_id);
      if (tipoCampoId === FieldTypeEnum.ListaEnum) {
        this.valorSelecionado = { id: this.condicao.valor, text: '' };
      } else if (tipoCampoId === FieldTypeEnum.ListaRelacionamento) {
        this.valorSelecionado = Array.isArray(this.condicao.valor) ? this.condicao.valor : [this.condicao.valor];
      }
    }
  }

  patchCampoCondicao(campo: any): void {
    this.condicaoForm.patchValue({
      campo_id: campo ? (campo.campo_id ?? campo.id) : null,
      campo_text: campo ? this.getCampoText(campo) : null,
      tipo_campo_id: campo ? campo.tipo_campo_id : null,
      campo_chave: campo ? campo.chave : null,
      campo_personalizado_id: campo?.campo_personalizado_id || null,
      operador_id: null,
      valor: null
    });

    this.valorSelecionado = null;
    this.carregaOperadores(campo ? campo.tipo_campo_id : null);
  }

  salvar(): void {
    if (this.condicaoForm.invalid) {
      this.condicaoForm.markAllAsTouched();
      return;
    }

    this.modal.close(this.condicaoForm.value);
  }

  close(): void {
    this.modal.dismiss();
  }

  private getCampoText(campo: any): string {
    return campo.text || campo.label || campo.nome || campo.descricao;
  }
}
